/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.querySelectorAll(".prdgalleyMute, .glb_mute, .mutedButton").forEach((btn) => {
    btn.addEventListener("click", function () {
      const parentDiv = btn.parentElement; // find nearest parent div
      const currentVideo = parentDiv.querySelector("video");
      if (currentVideo && !currentVideo.paused) {
        document.querySelectorAll(".video_selector").forEach((wrapper) => {
          const video = wrapper.querySelector("video");
          const playBtn = wrapper.querySelector('.glb_play');
          const posterWrapper = wrapper.querySelector(".custom-poster-wrapper");
          if (video !== currentVideo && !video.paused) {
            console.log("inn...")
            video.muted = true;
            //video.pause();
            const parentDivELe = video.parentElement;
            const muteBtn = parentDivELe.querySelector(
              ".prdgalleyMute, .glb_mute, .mutedButton"
            );
            if (muteBtn) {
              muteBtn.classList.add("muted");
            }
          }
          else{
            console.log("outt...")
          }
        });
      }
    });
  });
  function offsoundAllVideos( trigger = null ) {
    let posterWrapper = '';
    console.log("call the video pause",trigger)
    const isMobile = window.innerWidth <= 767;

    const allOtherVideos = document.querySelectorAll('.video_selector');
    allOtherVideos.forEach((wrapper) => {
      const video = wrapper.querySelector("video");
      const playBtn = wrapper.querySelector('.glb_play');
      posterWrapper = wrapper.querySelector(".custom-poster-wrapper");
      video.muted = true;
      video.pause();
      playBtn?.classList.remove('playing');
      if (posterWrapper) posterWrapper.style.opacity = 1;
      const parentDiv = video.parentElement;
      // find any button matching one of these classes
      const muteBtn = parentDiv.querySelector(
        ".prdgalleyMute, .glb_mute, .mutedButton"
      );
      if (muteBtn) {
        muteBtn.classList.add("muted");
      }
    });




    const videoWrappers = document.querySelectorAll('.video_selector');
    videoWrappers.forEach((wrapper) => {
      const video = wrapper.querySelector('video');

      

      const muteBtn = wrapper.querySelector('.glb_mute');
      const playBtn = wrapper.querySelector('.glb_play');
      posterWrapper = wrapper.querySelector(".custom-poster-wrapper");
      const shouldAutoplay = () => (isMobile ? video.dataset.autoplayM : video.dataset.autoplay) === 'true';
      if( shouldAutoplay() )
      {
        if (video) {
          video.muted = true;
          video.pause();
          playBtn?.classList.remove('playing');
          if (posterWrapper) posterWrapper.style.opacity = 1;
          if (muteBtn) {
            muteBtn.classList.add('muted');
          }
        }
      }
      else{
        video.pause();
        playBtn?.classList.remove('playing');
        if (posterWrapper) posterWrapper.style.opacity = 1;
      }
    });
    

  }

  function initCustomVideoPlayerWithHLS(sectionId) {
    let thresholdValue = 0.2;
    setTimeout(() => {
      thresholdValue = 0.6;
    }, 7000);

    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (!section) return;

    const videoAutoplay = section.dataset.videoAutoplay === "true";

    const videoWrappers = section.querySelectorAll('.video_selector');
    const isMobile = window.innerWidth <= 767;

    function loadHlsJs(callback) {
      if (window.Hls) {
        callback();
        return;
      }
      const script = document.createElement('script');
      script.src = "https://cdn.jsdelivr.net/npm/hls.js@latest";
      script.onload = () => callback();
      document.head.appendChild(script);
    }

    videoWrappers.forEach((wrapper) => {
      const video = wrapper.querySelector('video');
      if (!video || video.dataset.initialized === 'true') return;
      video.dataset.initialized = 'true';

      const getSrc = () => isMobile ? video.dataset.mobileVideo : video.dataset.desktopVideo;
      const getPoster = () => isMobile ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      const shouldAutoplay = () => (isMobile ? video.dataset.autoplayM : video.dataset.autoplay) === 'true';
      const showMute = (isMobile ? video.dataset.muteM : video.dataset.mute) === 'true';
      const showFullscreen = (isMobile ? video.dataset.fullscreenM : video.dataset.fullscreen) === 'true';

      const playBtn = wrapper.querySelector('.glb_play');
      const muteBtn = wrapper.querySelector('.glb_mute');
      const fullscreenBtn = wrapper.querySelector('.glb_fullscreen');

            


      let hls = null;
      let isNativeHLS = false;
      let isVideoLoaded = false;

      // Poster layer
      const posterUrl = getPoster();
      const posterWrapper = document.createElement('picture');
      posterWrapper.className = 'custom-poster-wrapper';
      Object.assign(posterWrapper.style, {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1,
        background: `url('${posterUrl}') center center / cover no-repeat`,
        pointerEvents: 'none',
        transition: 'opacity 0.4s ease',
        opacity: 1
      });

      wrapper.style.position = 'relative';
      wrapper.appendChild(posterWrapper);
      video._posterWrapper = posterWrapper;

      // Setup video
      var mtp = false;
      video.removeAttribute('muted');
      if( shouldAutoplay() )
      {
        var mtp = true;
        video.setAttribute('muted', '');
        
      }
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('preload', 'metadata');
      
      video.muted = mtp;

      function safePlay() {
        const playPromise = video.play();
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise
            .then(() => {
              playBtn?.classList.add('playing');
              
            })
            .catch(() => {
              playBtn?.classList.remove('playing');
              if (posterWrapper) posterWrapper.style.opacity = 1;
            });
        }
      }

      video.addEventListener('playing', () => {
        // Hide poster only when video is actually rendering
        if (posterWrapper) posterWrapper.style.opacity = 0;
      });


      function pauseVideo( otherVideo = null, vWrapper = null ) {
        if( otherVideo )
        {
          otherVideo.pause();
          let otherPlayBtn = vWrapper.querySelector('.glb_play');
          otherPlayBtn?.classList.remove('playing');
          let otherPosterWrapper = vWrapper.querySelector('.custom-poster-wrapper');
          if (otherPosterWrapper) otherPosterWrapper.style.opacity = 1;
        }
        else{
          video.pause();
          playBtn?.classList.remove('playing');
          if (posterWrapper) posterWrapper.style.opacity = 1;
        }
      }

      function loadVideo() {
        const src = getSrc();
        var autoplay = shouldAutoplay();

        if( autoplay && video )
        {
          video.muted = true;
          if (muteBtn) {
            muteBtn.classList.add('muted');
          }
        }
        if (isVideoLoaded && video.getAttribute('data-loaded-src') === src) {
          if (autoplay) safePlay();
          return;
        }

        video.setAttribute('data-loaded-src', src);
        isNativeHLS = src.endsWith('.m3u8') && video.canPlayType('application/vnd.apple.mpegurl') !== '';
        if (src.endsWith('.m3u8')) {
          if (isNativeHLS) {
            video.src = src;
            video.setAttribute('preload', 'auto');
            video.load();
            isVideoLoaded = true;
            video.addEventListener('loadedmetadata', () => {
              if (autoplay) safePlay();
            }, { once: true });
          } 
          else 
          {
            loadHlsJs(() => {
              if (window.Hls && Hls.isSupported()) {
                hls = new Hls({ 
                  maxBufferLength: 3,
                  startLevel: -1,      
                  capLevelToPlayerSize: true
                });
                hls.loadSource(src);
                hls.attachMedia(video);
                video.hlsInstance = hls;

                hls.on(Hls.Events.MANIFEST_PARSED, () => {
                  isVideoLoaded = true;
                  if (autoplay) safePlay();
                });
              }
            })
          }
        } else {
          const source = document.createElement('source');
          source.src = src;
          source.type = 'video/mp4';
          video.appendChild(source);
          video.load();
          isVideoLoaded = true;
          video.addEventListener('loadedmetadata', () => {
            if (autoplay) safePlay();
          }, { once: true });
        }

        playBtn?.classList.toggle('playing', autoplay);
        //playBtn?.style.setProperty('display', autoplay ? 'none' : 'block');
        //if (posterWrapper) posterWrapper.style.opacity = autoplay ? 0 : 1;
      }

      function isVisible(entry, wrap) {
        const rect = entry.boundingClientRect;
        const intersection = entry.intersectionRect;
        const visibleRatio = intersection.width / rect.width;
        return visibleRatio >= thresholdValue && entry.isIntersecting;
      }

      function isOutOfView(el) {
        const rect = el.getBoundingClientRect();
        return (
          rect.bottom < 0 ||
          rect.top > window.innerHeight ||
          rect.right < 0 ||
          rect.left > window.innerWidth
        );
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const wrap = entry.target.closest('.video_selector');
          if (!wrap) return;
          const shouldPlay = isVisible(entry, wrap) && !isOutOfView(wrap);
          
          if (shouldPlay) {
            loadVideo();
          } else {
            pauseVideo();
          }
        });
      }, {
        threshold: Array.from({ length: 21 }, (_, i) => i / 20),
      });

      observer.observe(video);

      // Controls
      playBtn?.addEventListener('click', () => {
        if (video.paused) {
          offsoundAllVideos('trigger');
          safePlay();
          video.muted = false;
          if (muteBtn) {
            muteBtn.classList.remove('muted');
          }
        } else {
          if (muteBtn) {
            muteBtn.classList.add('muted');
          }
          pauseVideo();
        }
      });

      if (muteBtn) {
        muteBtn.style.display = showMute ? 'block' : 'none';
        muteBtn.classList.toggle('muted', video.muted);
        muteBtn.addEventListener('click', () => {
          video.muted = !video.muted;
          muteBtn.classList.toggle('muted', video.muted);
        });
      }

      if (fullscreenBtn) {
        fullscreenBtn.style.display = showFullscreen ? 'block' : 'none';
        fullscreenBtn.addEventListener('click', () => {
          if (video.requestFullscreen) {
            video.requestFullscreen();
          } else if (video.webkitEnterFullscreen) {
            video.webkitEnterFullscreen();
          } else if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen();
          }
        });
      }
    });
  }
  function initModalVideoPlayerWithHLS(sectionId) {
    
    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (!section) return;

    const videoAutoplay = section.dataset.videoAutoplay === "true";

    const videoWrappers = section.querySelectorAll('.video_selector');
    const isMobile = window.innerWidth <= 767;

    function loadHlsJs(callback) {
      if (window.Hls) {
        callback();
        return;
      }
      const script = document.createElement('script');
      script.src = "https://cdn.jsdelivr.net/npm/hls.js@latest";
      script.onload = () => callback();
      document.head.appendChild(script);
    }

    videoWrappers.forEach((wrapper) => {
      const video = wrapper.querySelector('video');
      if (!video) return;
      video.dataset.initialized = 'true';

      const getSrc = () => isMobile ? video.dataset.mobileVideo : video.dataset.desktopVideo;
      const getPoster = () => isMobile ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      const shouldAutoplay = () => (isMobile ? video.dataset.autoplayM : video.dataset.autoplay) === 'true';
      const showMute = (isMobile ? video.dataset.muteM : video.dataset.mute) === 'true';
      const showFullscreen = (isMobile ? video.dataset.fullscreenM : video.dataset.fullscreen) === 'true';
      const muteBtn = wrapper.querySelector('.glb_mute');
      let hls = null;
      let isNativeHLS = false;
      let isVideoLoaded = false;
      // Poster layer
      const posterUrl = getPoster();
      const posterWrapper = document.createElement('picture');
      posterWrapper.className = 'custom-poster-wrapper';
      Object.assign(posterWrapper.style, {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1,
        background: `url('${posterUrl}') center center / cover no-repeat`,
        pointerEvents: 'none',
        transition: 'opacity 0.4s ease',
        opacity: 1
      });

      wrapper.style.position = 'relative';
      wrapper.appendChild(posterWrapper);
      video._posterWrapper = posterWrapper;

      
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('preload', 'metadata');
      
      video.muted = false;
      muteBtn.classList.remove('muted');

      function safePlay() {
        const playPromise = video.play();
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise
            .then(() => {
              if (posterWrapper) posterWrapper.style.opacity = 0;
              
            })
            .catch(() => {
              if (posterWrapper) posterWrapper.style.opacity = 1;
            });
        }
      }
      const progressBar = section.querySelector('#videoModal .progress-bar');

      video.addEventListener('timeupdate', () => {
        if (video.duration) {
          const progressPercent = (video.currentTime / video.duration) * 100;
          progressBar.style.width = progressPercent + "%";
        }
      });
      
      function loadVideo() {
        const src = getSrc();
        var autoplay = shouldAutoplay();
        isNativeHLS = src.endsWith('.m3u8') && video.canPlayType('application/vnd.apple.mpegurl') !== '';
        if (src.endsWith('.m3u8')) {
          if (isNativeHLS) {
            video.src = src;
            video.setAttribute('preload', 'auto');
            video.load();
            isVideoLoaded = true;
            video.addEventListener('loadedmetadata', () => {
              if (autoplay) safePlay();
            }, { once: true });
          } 
          else 
          {
            loadHlsJs(() => {
              if (window.Hls && Hls.isSupported()) {
                hls = new Hls({ 
                  maxBufferLength: 3,
                  startLevel: -1,      
                  capLevelToPlayerSize: true
                });
                hls.loadSource(src);
                hls.attachMedia(video);
                video.hlsInstance = hls;

                hls.on(Hls.Events.MANIFEST_PARSED, () => {
                  isVideoLoaded = true;
                  if (autoplay) safePlay();
                });
              }
            })
          }
        } else {
          const source = document.createElement('source');
          source.src = src;
          source.type = 'video/mp4';
          video.appendChild(source);
          video.load();
          isVideoLoaded = true;
          video.addEventListener('loadedmetadata', () => {
            if (autoplay) safePlay();
          }, { once: true });
        }

        if (autoplay)
        { 
          safePlay();
          video.onended = () => {
            const activeItem = section.querySelector('.product_in_use_slider_item.active');
            if (!activeItem) return;
            const currentThumb = activeItem.querySelector('.video-thumb');
            if (!currentThumb) return;
            const thumbs = [...section.querySelectorAll('.video-thumb')];
            const currentIndex = thumbs.indexOf(currentThumb);

            // pick next (or loop to first)
            let nextThumb = thumbs[currentIndex + 1] || thumbs[0];
            console.log("nextThumb",nextThumb)
            // update active class
            section.querySelectorAll('.product_in_use_slider_item.active').forEach(item => item.classList.remove('active'));
            nextThumb.closest('.product_in_use_slider_item')?.classList.add('active');
            // trigger click on next thumb
            nextThumb.click();
          }
        }
      }
      loadVideo();
      

      if (muteBtn && !muteBtn.dataset.listenerAttached) {
        muteBtn.style.display = 'block';
        muteBtn.addEventListener('click', () => {
          video.muted = !video.muted;
          muteBtn.classList.toggle('muted', video.muted);
        });
        muteBtn.dataset.listenerAttached = "true";
      }

      
    });
  }
  function initTextIconSlider(section){
    const slider = section.querySelector(".text-icon-slider__inner");
    if (!slider) return;

    const items = slider.querySelectorAll(".text-icon-slider__item");
    if (!items.length) return;

    const desktop = parseInt(slider.dataset.desktop || 5, 10);
    const tablet  = parseInt(slider.dataset.tablet  || 3, 10);
    const mobile  = parseInt(slider.dataset.mobile  || 2, 10);

    const confirm_autoplay = slider.dataset.autoplay == "true" 
    const confirm_autoplay_m = slider.dataset.autoplayM == "true"
    const autoplay_interval = slider.dataset.interval


    const getSlidesToShow = () => {
      if (window.innerWidth < 768) return mobile;
      if (window.innerWidth < 1024) return tablet;
      return desktop;
    };

    const setCellWidths = (count) => {
      const width = (100 / Math.max(1, count)) + '%';
      items.forEach(el => { el.style.width = width; });
    };

    const clearCellWidths = () => {
      items.forEach(el => { el.style.width = ''; });
    };

    const getButtons = () => {
      return {
        prev: slider.querySelector('.flickity-button.previous'),
        next: slider.querySelector('.flickity-button.next')
      };
    };

    const updateButtons = (flkty) => {
      const perView = getSlidesToShow();
      const lastIndex = Math.max(0, flkty.cells.length - perView);
      const atStart = flkty.selectedIndex <= 0;
      const atEnd   = flkty.selectedIndex >= lastIndex;

      const { prev, next } = getButtons();
      if (prev) {
        prev.disabled = atStart;
        prev.classList.toggle('is-disabled', atStart);
      }
      if (next) {
        next.disabled = atEnd;
        next.classList.toggle('is-disabled', atEnd);
      }
    };

    const clampToBounds = (flkty) => {
      const perView = getSlidesToShow();
      const lastIndex = Math.max(0, flkty.cells.length - perView);
      if (flkty.selectedIndex > lastIndex) {
        flkty.select(lastIndex, false, false);
      }
    };

    const ensureSlider = () => {
      const perView = getSlidesToShow();
      const autoplay = (window.innerWidth < 768) ? confirm_autoplay_m : confirm_autoplay;

      console.log("autoplay", autoplay);

      // Not enough items – destroy & show static row
      if (items.length <= perView) {
        if (slider.flickityInstance) {
          slider.flickityInstance.destroy();
          slider.flickityInstance = null;
        }
        clearCellWidths();
        return;
      }

      // Enough items – ensure widths + init/refresh
      setCellWidths(perView);

      // ✅ Create or re-init if autoplay setting changes
      if (!slider.flickityInstance || slider.flickityInstance.options.autoPlay !== (autoplay ? autoplay_interval : false)) {

        // Destroy previous instance (if exists)
        if (slider.flickityInstance) {
          slider.flickityInstance.destroy();
          slider.flickityInstance = null;
        }

        // ✅ Initialize new Flickity instance
        slider.flickityInstance = new window.theme.Flickity(slider, {
          cellAlign: "left",
          contain: false,
          pageDots: false,
          prevNextButtons: true,
          autoPlay: autoplay ? autoplay_interval : false, // autoplay toggle
          pauseAutoPlayOnHover: true,                     // optional
          wrapAround: true,                               // recommended for autoplay
          groupCells: false,
          draggable: true,
        });

        // Keep arrows correct & index clamped
        // slider.flickityInstance.on('ready', () => {
        //   clampToBounds(slider.flickityInstance);
        //   updateButtons(slider.flickityInstance);
        // });
        // slider.flickityInstance.on('change', () => {
        //   clampToBounds(slider.flickityInstance);
        //   updateButtons(slider.flickityInstance);
        // });
        // slider.flickityInstance.on('settle', () => {
        //   clampToBounds(slider.flickityInstance);
        //   updateButtons(slider.flickityInstance);
        // });

      } else {
        // ✅ Just refresh layout if no autoplay change
        slider.flickityInstance.reloadCells();
        slider.flickityInstance.resize();
        // clampToBounds(slider.flickityInstance);
        // updateButtons(slider.flickityInstance);
      }
    };


    // Initial
    ensureSlider();

    // Debounced resize
    const onResize = () => {
      clearTimeout(slider._resizeTimer);
      slider._resizeTimer = setTimeout(() => {
        ensureSlider();
      }, 150);
    };
    window.addEventListener('resize', onResize);

    // In Customizer, re-init on section reload
    document.addEventListener('shopify:section:load', (ev) => {
      if (ev.target && ev.target.contains(slider)) {
        ensureSlider();
      }
    });
  }



  document.addEventListener("shopify:section:load", function(e) {
    initTextIconSlider(e.target);
  });
  document.querySelectorAll(".text-icon-slider").forEach(initTextIconSlider);

  function initCustomerQuotesSlider(sectionEl) {
    const slider = sectionEl.querySelector('[data-customer-quotes]');
    if (!slider) return;

    // Destroy old instance if exists
    if (slider.flickityInstance) {
      slider.flickityInstance.destroy();
      slider.flickityInstance = null;
    }

    // Init Flickity
    slider.flickityInstance = new window.theme.Flickity(slider, {
      cellSelector: '.quote-slide',
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      fade: true,
      draggable: true,
      adaptiveHeight: false,
      autoPlay: 5000 // auto fade every 5s
    });
  }

  // Init on page load
  document.querySelectorAll('[data-customer-quotes]').forEach(el => {
    initCustomerQuotesSlider(el.closest('section'));
  });

  // Re-init in theme editor (Shopify Customizer)
  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.querySelector('[data-customer-quotes]')) {
      initCustomerQuotesSlider(e.target);
    }
  });
  document.addEventListener('shopify:section:unload', function(e) {
    const slider = e.target.querySelector('[data-customer-quotes]');
    if (slider?.flickityInstance) {
      slider.flickityInstance.destroy();
      slider.flickityInstance = null;
    }
  });

  function __initAfterBeforeTestimonial(section) {
    const desktop = parseInt(section.dataset.desktop) || 3;
    const tablet  = parseInt(section.dataset.tablet)  || 2;
    const mobile  = parseInt(section.dataset.mobile)  || 1;
    const autoPlay = parseInt(section.dataset.autoplay) || 3000;
    const wrap = section.dataset.wrap === "true";

    const alignment = ( section.dataset.align == "left" ) ? 'left' : 'center';

    function getGroupCells() {
        if (window.innerWidth >= 1024) return desktop;
        if (window.innerWidth >= 768) return tablet;
        return mobile;
    }

    function alignment_des() {
        if (window.innerWidth >= 1024)
        {
          return alignment;
        }
        return 'left';
    }
    const totalSlides = section.querySelectorAll(".slider .carousel-cell").length;
    const slidesToShow = getGroupCells();

    const contain_v = ( totalSlides > slidesToShow ) ? false : true;
    const wrap_v = ( totalSlides > slidesToShow ) ? true : false;
    
    

    const flkty = new window.theme.Flickity(section.querySelector(".slider"), {
        cellAlign: alignment_des(),
        contain: contain_v,
        imagesLoaded: true,
        wrapAround: wrap_v,
        autoPlay: false,
        prevNextButtons: wrap_v,
        pageDots: false,
        draggable: wrap_v,   
        touchVerticalScroll: false,
        adaptiveHeight: false,
    });

    
    let lastWidth = window.innerWidth;
    window.addEventListener("resize", () => {
      if (window.innerWidth !== lastWidth) {
        lastWidth = window.innerWidth;
        flkty.resize();
      }
    });
    const modal = section.querySelector(".readMoreModal");
    const modalContent = modal?.querySelector(".modal-content .content");
    const closeBtn = modal?.querySelector(".close");
    const readMore_button = section.querySelectorAll(".read-more-btn"); 

    if (closeBtn) {
        closeBtn.addEventListener("click", () => {
            modal.classList.remove("open")
        });
    }
    window.addEventListener("click", (event) => {
        if (event.target === modal) {
            modal.classList.add("open")
        }
    });
    readMore_button.forEach(button => {
        button.addEventListener('click', (event) => {
            const parent = event.target.closest('.slide-item-content-desc');
            const parentInnertext = parent.querySelector(".descriptions_full");
            modalContent.innerHTML = parentInnertext.innerHTML;
            modal.classList.add("open")
        });
    });
  }
  function initAfterBeforeTestimonial(section) {
    const desktop  = parseInt(section.dataset.desktop) || 3;
    const tablet   = parseInt(section.dataset.tablet)  || 2;
    const mobile   = parseInt(section.dataset.mobile)  || 1;
    const autoPlay = false;
    const wrap     = section.dataset.wrap === "true";
    const alignment = section.dataset.align === "left" ? "left" : "center";

    const slider = section.querySelector(".slider");
    const totalSlides = slider.querySelectorAll(".carousel-cell").length;

    function getGroupCells() {
      if (window.innerWidth > 1024) return desktop;
      if (window.innerWidth >= 768)  return tablet;
      return mobile;
    }

    function alignment_des() {
      return window.innerWidth > 1024 ? alignment : "left";
    }

    function getOptions() {
      const slidesToShow = getGroupCells();
      const contain_v = totalSlides <= slidesToShow;
      const wrap_v    = totalSlides > slidesToShow;

      return {
        cellAlign: alignment_des(),
        contain: contain_v,
        imagesLoaded: true,
        wrapAround: wrap_v,
        autoPlay: autoPlay > 0 ? autoPlay : false,
        prevNextButtons: wrap_v,
        pageDots: false,
        draggable: wrap_v,
        touchVerticalScroll: false,
        adaptiveHeight: false,
      };
    }

    // init Flickity
    let flkty = new window.theme.Flickity(slider, getOptions());

    // reinit on resize if breakpoint changes
    let lastSlidesToShow = getGroupCells();
    let lastAlign = alignment_des();

    window.addEventListener("resize", () => {
      const newSlidesToShow = getGroupCells();
      const newAlign = alignment_des();

      if (newSlidesToShow !== lastSlidesToShow || newAlign !== lastAlign) {
        flkty.destroy();
        flkty = new window.theme.Flickity(slider, getOptions());
        lastSlidesToShow = newSlidesToShow;
        lastAlign = newAlign;
      } else {
        flkty.resize();
      }
    });

    // Modal handling
    const modal        = section.querySelector(".readMoreModal");
    const modalContent = modal?.querySelector(".modal-content .content");
    const closeBtn     = modal?.querySelector(".close");
    const readMoreBtns = section.querySelectorAll(".read-more-btn");

    if (modal && modalContent) {
      if (closeBtn) {
        closeBtn.addEventListener("click", () => modal.classList.remove("open"));
      }

      // clicking overlay closes modal (not opens)
      window.addEventListener("click", (event) => {
        if (event.target === modal) {
          modal.classList.remove("open");
        }
      });

      readMoreBtns.forEach(button => {
        button.addEventListener("click", (event) => {
          const parent = event.target.closest(".slide-item-content-desc");
          const parentInnerText = parent?.querySelector(".descriptions_full");
          if (parentInnerText) {
            modalContent.innerHTML = parentInnerText.innerHTML;
            modal.classList.add("open");
          }
        });
      });
    }
  }

  document.querySelectorAll(".after_before_testimonial").forEach(section => {
    const sectionID = section.getAttribute('data-section-id');
    initCustomVideoPlayerWithHLS(sectionID);
    initAfterBeforeTestimonial(section);
  });
  document.addEventListener("shopify:section:load", function(event) {
    const section = event.target.querySelector(".after_before_testimonial");
    if (section) {
      const sectionID = section.getAttribute('data-section-id');
      initCustomVideoPlayerWithHLS(sectionID);
      initAfterBeforeTestimonial(section);
    }
  });

  function animateCircle(el) {
    let percent = parseInt(el.dataset.percent, 10);
    let circle = el.querySelector(".circle");
    let leftMask = circle.querySelector(".mask.full .fill");
    let rightMask = circle.querySelector(".mask.half .fill");
    let numberEl = circle.querySelector(".percent");
    let current = 0;

    let interval = setInterval(() => {
      if (current >= percent) {
        clearInterval(interval);
      } else {
        current++;
        numberEl.textContent = current;

        let deg = current * 3.6; // 100% = 360deg
        if (deg <= 180) {
          rightMask.style.transform = `rotate(${deg}deg)`;
        } else {
          rightMask.style.transform = `rotate(180deg)`;
          leftMask.style.transform = `rotate(${deg - 180}deg)`;
        }
      }
    }, 20);
  }

  // Run when visible
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateCircle(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.5, // 50% of element must be visible
    }
  );

  document.querySelectorAll(".percent__block .progress").forEach((el) => {
    observer.observe(el);
  });



  
  function initBlogSlider(section){
    const desktop = parseInt(section.dataset.desktop) || 3;
    const tablet  = parseInt(section.dataset.tablet)  || 2;
    const mobile  = parseInt(section.dataset.mobile)  || 1;
    const autoPlay = parseInt(section.dataset.autoplay) || 3000;
    const wrap = section.dataset.wrap === "true";

    function getGroupCells() {
        if (window.innerWidth >= 1024) return desktop;
        if (window.innerWidth >= 768) return tablet;
        return mobile;
    }
    const totalSlides = section.querySelectorAll(".blog-slider .article.grid-item").length;
    const slidesToShow = getGroupCells();

    const contain_v = ( totalSlides > slidesToShow ) ? false : true;
    const wrap_v = ( totalSlides > slidesToShow ) ? true : false;
    

    const flkty = new window.theme.Flickity(section.querySelector(".blog-slider"), {
        cellAlign: "left",
        contain: contain_v,
        imagesLoaded: true,
        wrapAround: wrap_v,
        autoPlay: false,
        prevNextButtons: true,
        pageDots: false,
        draggable: wrap_v,   
        touchVerticalScroll: false,
    });
    window.addEventListener("resize", () => {
        flkty.resize();
    });
  }
  document.querySelectorAll(".blog-slider-wrapper").forEach(section => {
    initBlogSlider(section);
  });
  document.addEventListener("shopify:section:load", function(event) {
    const section = event.target.querySelector(".blog-slider-wrapper");
    if (section) {
      initBlogSlider(section);
    }
  });

  function initProductInUseSlider(section){
    const slider = section.querySelector(".product_in_use_slider");
    if( !slider ) return;
    const desktop = parseInt(slider.dataset.desktop) || 5;
    const tablet  = parseInt(slider.dataset.tablet)  || 3;
    const mobile  = parseInt(slider.dataset.mobile)  || 2;
    const autoPlay = parseInt(slider.dataset.autoplay) || 3000;
    const wrap = slider.dataset.wrap === "true";

    function getGroupCells() {
        if (window.innerWidth >= 1024) return desktop;
        if (window.innerWidth >= 768) return tablet;
        return mobile;
    }
    const totalSlides = slider.querySelectorAll(".product_in_use_slider_item").length;
    const slidesToShow = getGroupCells();

    const contain_v = ( totalSlides > slidesToShow ) ? false : true;
    const wrap_v = ( totalSlides > slidesToShow ) ? true : false;
    

    const flkty = new window.theme.Flickity(slider, {
        cellAlign: "left",
        contain: contain_v,
        imagesLoaded: true,
        wrapAround: wrap_v,
        autoPlay: false,
        prevNextButtons: true,
        pageDots: false,
        draggable: wrap_v,   
        touchVerticalScroll: false,
    });
    window.addEventListener("resize", () => {
        flkty.resize();
    });
    // open modal on thumbnail click
    section.querySelectorAll('.video-thumb').forEach(thumb => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.videoSrc;
        const poster = thumb.dataset.poster;

        const modal = section.querySelector('#videoModal');
        const video = modal.querySelector('video');
        // set dataset so init function can pick it up
        video.dataset.desktopVideo = src;
        video.dataset.mobileVideo = src;
        video.dataset.desktopPoster = poster;
        video.dataset.mobilePoster = poster;
        modal.classList.add('open');

        const title = thumb.dataset.title;
        modal.querySelector(".title_and_btns h2").innerHTML = title;
        const progressBar = modal.querySelector('.progress-bar');
        progressBar.style.width =  "0%";
        const parentItem = thumb.closest('.product_in_use_slider_item');
        if (parentItem) {
          section.querySelectorAll('.product_in_use_slider_item').forEach(el => el.classList.remove('active')); 
          parentItem.classList.add('active');
        }
        // init your player inside modal
        initModalVideoPlayerWithHLS(section.getAttribute('data-section-id'));
      });
    });

    function showNext() {
        const activeItem = section.querySelector('.product_in_use_slider_item.active');
        if (!activeItem) return;

        const currentThumb = activeItem.querySelector('.video-thumb');
        if (!currentThumb) return;

        const thumbs = [...section.querySelectorAll('.video-thumb')];
        const currentIndex = thumbs.indexOf(currentThumb);

        // pick next (or loop to first)
        const nextThumb = thumbs[currentIndex + 1] || thumbs[0];

        // update active class
        section.querySelectorAll('.product_in_use_slider_item.active')
              .forEach(item => item.classList.remove('active'));
        nextThumb.closest('.product_in_use_slider_item')?.classList.add('active');

        // trigger click on next thumb
        nextThumb.click();
      }
      
      function showPrev() {
        const activeItem = section.querySelector('.product_in_use_slider_item.active');
        if (!activeItem) return;

        const currentThumb = activeItem.querySelector('.video-thumb');
        if (!currentThumb) return;

        const thumbs = [...section.querySelectorAll('.video-thumb')];
        const currentIndex = thumbs.indexOf(currentThumb);

        // pick prev (or loop to last)
        const prevThumb = thumbs[currentIndex - 1] || thumbs[thumbs.length - 1];

        // update active class
        section.querySelectorAll('.product_in_use_slider_item.active')
              .forEach(item => item.classList.remove('active'));
        prevThumb.closest('.product_in_use_slider_item')?.classList.add('active');

        // trigger click on prev thumb
        prevThumb.click();
      }
      section.querySelector('.glb_next').addEventListener('click', () => showNext());
      section.querySelector('.glb_prev').addEventListener('click', () => showPrev());

    // close modal
    section.querySelectorAll('#videoModal .modal-close, #videoModal .modal-overlay').forEach(el => {
      el.addEventListener('click', () => {
        const modal = section.querySelector('#videoModal');
        const video = modal?.querySelector('video');
        if (video) {
          video.pause();
          if (video.hlsInstance) {
            video.hlsInstance.destroy();
            video.hlsInstance = null;
          }
        }
        modal?.classList.remove('open');
      });
    });

    

  }
  document.querySelectorAll("product-component").forEach(section => {
    initProductInUseSlider(section);
  });
  document.addEventListener("shopify:section:load", function(event) {
    const section = event.target.querySelector("product-component");
    if (section) {
      initProductInUseSlider(section);
    }
  });


  document.querySelectorAll(".init_hls_video_player").forEach(section => {
    const sectionID = section.getAttribute('data-section-id');
          console.log("dfff----",sectionID)

    initCustomVideoPlayerWithHLS(sectionID);
  });
  document.addEventListener("shopify:section:load", function(event) {
    const section = event.target.querySelector(".init_hls_video_player");
    if (section) {
      const sectionID = section.getAttribute('data-section-id');
      initCustomVideoPlayerWithHLS(sectionID);
    }
  });


  // MULICOLUMN
  // Multicolumn Mobile Slider Autoplay (using existing grid--mobile-slider)
  function initMulticolumnMobileAutoplay() {
    console.log('Multicolumn Mobile Autoplay: Looking for autoplay wrappers');
    
    document.querySelectorAll('.multicolumn-autoplay-wrapper').forEach((wrapper, index) => {
      console.log(`Multicolumn Mobile Autoplay: Found wrapper ${index + 1}:`, wrapper);
      
      const grid = wrapper.querySelector('.grid--mobile-slider');
      if (!grid) {
        console.log('Multicolumn Mobile Autoplay: No grid--mobile-slider found in wrapper');
        return;
      }

      const autoplaySpeed = parseInt(wrapper.dataset.autoplaySpeed) || 4000;
      const pauseOnHover = wrapper.dataset.pauseOnHover === 'true';
      
      console.log('Multicolumn Mobile Autoplay: Settings - speed:', autoplaySpeed, 'pauseOnHover:', pauseOnHover);

      // Check if Flickity is available
      if (typeof window.theme === 'undefined' || typeof window.theme.Flickity === 'undefined') {
        console.error('Multicolumn Mobile Autoplay: Flickity not available');
        return;
      }

      // Store settings for responsive behavior
      wrapper.autoplaySettings = {
        speed: autoplaySpeed,
        pauseOnHover: pauseOnHover
      };

      // Initialize or update slider based on screen size
      updateSliderForScreenSize(wrapper);
    });
  }

  // Function to update slider based on screen size
  function updateSliderForScreenSize(wrapper) {
    const grid = wrapper.querySelector('.grid--mobile-slider');
    if (!grid) return;

    const isMobile = window.innerWidth < 750; // Mobile breakpoint
    const autoplayEnabled = wrapper.dataset.autoplay !== undefined && wrapper.dataset.autoplay !== null;
    const shouldBeSlider = isMobile && autoplayEnabled;

    console.log('Multicolumn Mobile Autoplay: Screen size check - isMobile:', isMobile, 'autoplayEnabled:', autoplayEnabled, 'shouldBeSlider:', shouldBeSlider);
    console.log('Multicolumn Mobile Autoplay: Data attributes:', {
      autoplay: wrapper.dataset.autoplay,
      pauseOnHover: wrapper.dataset.pauseOnHover
    });

    // Destroy existing instance
    if (grid.flickityInstance) {
      console.log('Multicolumn Mobile Autoplay: Destroying existing Flickity instance');
      grid.flickityInstance.destroy();
      grid.flickityInstance = null;
    }

    // Initialize slider only on mobile when autoplay is enabled
    if (shouldBeSlider) {
      try {
        const settings = wrapper.autoplaySettings || {
          speed: parseInt(wrapper.dataset.autoplaySpeed) || 4000,
          pauseOnHover: wrapper.dataset.pauseOnHover === 'true'
        };

        console.log('Multicolumn Mobile Autoplay: Initializing Flickity with autoplay');
        grid.flickityInstance = new window.theme.Flickity(grid, {
          cellAlign: "left",
          contain: false,
          wrapAround: true,
          prevNextButtons: true,
          pageDots: false,
          draggable: true,
          autoPlay: settings.speed,
          pauseAutoPlayOnHover: settings.pauseOnHover,
          imagesLoaded: true,
          adaptiveHeight: true,
          // groupCells: true,
          // groupCells: 1
        });

        console.log('Multicolumn Mobile Autoplay: Flickity initialized successfully');
      } catch (error) {
        console.error('Multicolumn Mobile Autoplay: Error initializing Flickity:', error);
      }
    }
  }

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', function() {
    initMulticolumnMobileAutoplay();
  });

  // Re-initialize on section load (for theme editor)
  document.addEventListener('shopify:section:load', function(e) {
    setTimeout(() => {
      initMulticolumnMobileAutoplay();
    }, 100);
  });

  // Handle resize events to switch between desktop grid and mobile slider
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      console.log('Multicolumn Mobile Autoplay: Window resized, updating sliders');
      document.querySelectorAll('.multicolumn-autoplay-wrapper').forEach(wrapper => {
        updateSliderForScreenSize(wrapper);
      });
    }, 150);
  });



  // INIT AUTO SLIDE OPTION
  document.addEventListener('click', function handler() {
    document.body.classList.add('clicked-anywhere');
    document.removeEventListener('click', handler);
  });
  
  function __safePlayUsingFlickity( section, videoWrapper )
  {
    //offsoundAllVideos();
    const playBtn = videoWrapper.querySelector('.glb_play');
    const video = videoWrapper.querySelector('.social_video_selector video');
    const videoPoster = videoWrapper.querySelector(".custom-poster-wrapper");

    const allVidesos = section.querySelectorAll('.social_video_selector video');
     
    video.addEventListener('play', () => {
      allVidesos.forEach(v => {
        if (v !== video) {
          v.pause();
          v.currentTime = 0;
        }
      });
    });
    video.addEventListener('ended', () => {
      const carousel = section.querySelector('.social-proof-slider-fl');
      const flkty = window.theme.Flickity.data(carousel);
      if (flkty) flkty.next();
    });

    // const carousel = section.querySelector('.social-proof-slider-fl');
    // const flkty = window.theme.Flickity.data(carousel);
    // const playPromise = video.play();
    // if (playPromise && typeof playPromise.then === 'function') {
    //   playPromise.then(() => {
    //     playBtn?.classList.add('playing');
    //     video.onended = () => {
    //       if (flkty) flkty.next();
    //     };
    //   })
    //   .catch(() => {
    //     playBtn?.classList.remove('playing');
    //     if (videoPoster) videoPoster.style.opacity = 1;
    //   });
    // }


  }
  function __initAutoPlayHlsVideos(sectionId) {
    let thresholdValue = 0.2;
    setTimeout(() => {
      thresholdValue = 0.6;
    }, 7000);

    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (!section) return;

    const videoAutoplay = section.dataset.videoAutoplay === "true";

    const videoWrappers = section.querySelectorAll('.social_video_selector');
    const isMobile = window.innerWidth <= 767;

    function loadHlsJs(callback) {
      if (window.Hls) {
        callback();
        return;
      }
      const script = document.createElement('script');
      script.src = "https://cdn.jsdelivr.net/npm/hls.js@latest";
      script.onload = () => callback();
      document.head.appendChild(script);
    }

    videoWrappers.forEach((wrapper) => {
      const video = wrapper.querySelector('video');
      if (!video || video.dataset.initialized === 'true') return;
      video.dataset.initialized = 'true';

      const getSrc = () => isMobile ? video.dataset.mobileVideo : video.dataset.desktopVideo;
      const getPoster = () => isMobile ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      //const shouldAutoplay = () => (isMobile ? video.dataset.autoplayM : video.dataset.autoplay) === 'true';
      const showMute = (isMobile ? video.dataset.muteM : video.dataset.mute) === 'true';
      const showFullscreen = (isMobile ? video.dataset.fullscreenM : video.dataset.fullscreen) === 'true';

      const playBtn = wrapper.querySelector('.glb_play');
      const muteBtn = wrapper.querySelector('.glb_mute');
      const fullscreenBtn = wrapper.querySelector('.glb_fullscreen');

      const shouldAutoplay = () => ( wrapper.closest('div.carousel-cell.is-selected') )

            


      let hls = null;
      let isNativeHLS = false;
      let isVideoLoaded = false;

      // Poster layer
      const posterUrl = getPoster();
      const posterWrapper = document.createElement('picture');
      posterWrapper.className = 'custom-poster-wrapper';
      Object.assign(posterWrapper.style, {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1,
        background: `url('${posterUrl}') center center / cover no-repeat`,
        pointerEvents: 'none',
        transition: 'opacity 0.4s ease',
        opacity: 1
      });

      wrapper.style.position = 'relative';
      wrapper.appendChild(posterWrapper);
      video._posterWrapper = posterWrapper;

      // Setup video
      var mtp = true;
      video.removeAttribute('muted');
      if( shouldAutoplay() )
      {
        var mtp = true;
        video.setAttribute('muted', '');
        
      }
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('preload', 'metadata');
      
      video.muted = mtp;

      function __safePlay() {
        const carousel = section.querySelector('.social-proof-slider-fl');
        const flkty = window.theme.Flickity.data(carousel);
        
        const playPromise = video.play();
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise.then(() => {
            playBtn?.classList.add('playing');
            video.onended = () => {
              if (flkty) flkty.next();
            };
          })
          .catch(() => {
            playBtn?.classList.remove('playing');
            if (posterWrapper) posterWrapper.style.opacity = 1;
          });
        }
      }
      function safePlay() {
        const carousel = section.querySelector('.social-proof-slider-fl');
        const flkty = window.theme.Flickity.data(carousel);
        if (!flkty) return;

        // 🔹 Get the parent .carousel-cell of this video
        const parentCell = video.closest('.carousel-cell');

        // 🔹 If it's not the selected slide, center it first
        if (parentCell && !parentCell.classList.contains('is-selected')) {
          const cellIndex = flkty.cells.findIndex(cell => cell.element === parentCell);
          if (cellIndex >= 0) {
            flkty.select(cellIndex); // center this slide
          }
        }

        // 🔹 Give Flickity a moment to settle before playing
        setTimeout(() => {
          const playPromise = video.play();

          if (playPromise && typeof playPromise.then === 'function') {
            playPromise
              .then(() => {
                playBtn?.classList.add('playing');

                // When video ends, move to next slide
                video.onended = () => {
                  if (flkty) flkty.next();
                };
              })
              .catch(() => {
                playBtn?.classList.remove('playing');
                if (posterWrapper) posterWrapper.style.opacity = 1;
              });
          }
        }, 300);
      }

      const allVidesos = section.querySelectorAll('.social_video_selector video');
     
      video.addEventListener('play', () => {
        video.muted = false;
        allVidesos.forEach(v => {
          if (v !== video) {
            v.pause();
            v.currentTime = 0;
          }
        });
      });
      video.addEventListener('ended', () => {
        const carousel = section.querySelector('.social-proof-slider-fl');
        const flkty = window.theme.Flickity.data(carousel);
        if (flkty) flkty.next();
      });


     

      video.addEventListener('playing', () => {
        // Hide poster only when video is actually rendering
        if (posterWrapper) posterWrapper.style.opacity = 0;
      });


      function pauseVideo( otherVideo = null, vWrapper = null ) {
        if( otherVideo )
        {
          otherVideo.pause();
          let otherPlayBtn = vWrapper.querySelector('.glb_play');
          otherPlayBtn?.classList.remove('playing');
          let otherPosterWrapper = vWrapper.querySelector('.custom-poster-wrapper');
          if (otherPosterWrapper) otherPosterWrapper.style.opacity = 1;
        }
        else{
          video.pause();
          playBtn?.classList.remove('playing');
          if (posterWrapper) posterWrapper.style.opacity = 1;
        }
      }

      function loadVideo() {
        const src = getSrc();
        var autoplay = shouldAutoplay();

        if( autoplay && video )
        {
          video.muted = true;
          if (muteBtn) {
            muteBtn.classList.add('muted');
          }
        }
        if (isVideoLoaded && video.getAttribute('data-loaded-src') === src) {
          if (autoplay) safePlay();
          return;
        }
        video.setAttribute('data-loaded-src', src);
        isNativeHLS = src.endsWith('.m3u8') && video.canPlayType('application/vnd.apple.mpegurl') !== '';
        if (src.endsWith('.m3u8')) {
          if (isNativeHLS) {
            video.src = src;
            video.setAttribute('preload', 'auto');
            video.load();
            isVideoLoaded = true;
            video.addEventListener('loadedmetadata', () => {
              if (autoplay) safePlay();
            }, { once: true });
          } 
          else 
          {
            loadHlsJs(() => {
              if (window.Hls && Hls.isSupported()) {
                hls = new Hls({ 
                  maxBufferLength: 3,
                  startLevel: -1,      
                  capLevelToPlayerSize: true
                });
                hls.loadSource(src);
                hls.attachMedia(video);
                video.hlsInstance = hls;

                hls.on(Hls.Events.MANIFEST_PARSED, () => {
                  isVideoLoaded = true;
                  if (autoplay) safePlay();
                });
              }
            })
          }
        } else {
          const source = document.createElement('source');
          source.src = src;
          source.type = 'video/mp4';
          video.appendChild(source);
          video.load();
          isVideoLoaded = true;
          video.addEventListener('loadedmetadata', () => {
            if (autoplay) safePlay();
          }, { once: true });
        }

        playBtn?.classList.toggle('playing', autoplay);
        //playBtn?.style.setProperty('display', autoplay ? 'none' : 'block');
        //if (posterWrapper) posterWrapper.style.opacity = autoplay ? 0 : 1;
      }

      function isVisible(entry, wrap) {
        const rect = entry.boundingClientRect;
        const intersection = entry.intersectionRect;
        const visibleRatio = intersection.width / rect.width;
        return visibleRatio >= thresholdValue && entry.isIntersecting;
      }

      function isOutOfView(el) {
        const rect = el.getBoundingClientRect();
        return (
          rect.bottom < 0 ||
          rect.top > window.innerHeight ||
          rect.right < 0 ||
          rect.left > window.innerWidth
        );
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const wrap = entry.target.closest('.social_video_selector');
          if (!wrap) return;
          const shouldPlay = isVisible(entry, wrap) && !isOutOfView(wrap);
          
          if (shouldPlay) {
            loadVideo();
          } else {
            pauseVideo();
          }
        });
      }, {
        threshold: Array.from({ length: 21 }, (_, i) => i / 20),
      });

      observer.observe(video);

      // Controls
      playBtn?.addEventListener('click', () => {
        if (video.paused) {
          safePlay();
          video.muted = false;
          if (muteBtn) {
            muteBtn.classList.remove('muted');
          }
        } else {
          if (muteBtn) {
            muteBtn.classList.add('muted');
          }
          pauseVideo();
        }
      });

      if (muteBtn) {
        muteBtn.style.display = showMute ? 'block' : 'none';
        muteBtn.classList.toggle('muted', video.muted);
        muteBtn.addEventListener('click', () => {
          video.muted = !video.muted;
          muteBtn.classList.toggle('muted', video.muted);
        });
      }

      if (fullscreenBtn) {
        fullscreenBtn.style.display = showFullscreen ? 'block' : 'none';
        fullscreenBtn.addEventListener('click', () => {
          if (video.requestFullscreen) {
            video.requestFullscreen();
          } else if (video.webkitEnterFullscreen) {
            video.webkitEnterFullscreen();
          } else if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen();
          }
        });
      }
    });
  }
  function safePlayUsingFlickity( section, videoWrapper )
  {
    //offsoundAllVideos(videoWrapper);
    const playBtn = videoWrapper.querySelector('.glb_play');
    const video = videoWrapper.querySelector('video');
    const videoPoster = videoWrapper.querySelector(".custom-poster-wrapper");

    const carousel = section.querySelector('.social-proof-slider-fl');
    const flkty = window.theme.Flickity.data(carousel);
    const playPromise = video.play();
    if (document.body.classList.contains('clicked-anywhere')) {
      video.muted = false;
    }

      
    
    if (playPromise && typeof playPromise.then === 'function') {
      playPromise.then(() => {
        playBtn?.classList.add('playing');
        video.onended = () => {
          video.pause();
          playBtn?.classList.remove('playing');
          if (videoPoster) videoPoster.style.opacity = 1;
          if (flkty) flkty.next();
        };
      })
      .catch(() => {
        playBtn?.classList.remove('playing');
        if (videoPoster) videoPoster.style.opacity = 1;
      });
    }
  }
  function offsoundAllVideos_social(currentWrapper = null) {
    const isMobile = window.innerWidth <= 767;
    const allOtherVideos = document.querySelectorAll('.customer_love_it_video');

    allOtherVideos.forEach((wrapper) => {
      // Skip the current (active) video
      if (currentWrapper && wrapper === currentWrapper) return;

      const video = wrapper.querySelector("video");
      const playBtn = wrapper.querySelector('.glb_play');
      const posterWrapper = wrapper.querySelector(".custom-poster-wrapper");
      const muteBtn = wrapper.querySelector(".glb_mute");

      if (!video) return;

      // Pause and mute all other videos
      video.pause();
      video.muted = true;

      // Reset UI states
      playBtn?.classList.remove('playing');
      if (posterWrapper) posterWrapper.style.opacity = 1;
      if (muteBtn) muteBtn.classList.add('muted');
    });
  }
  function initAutoPlayHlsVideos(sectionId) {
    let thresholdValue = 0.2;
    setTimeout(() => {
      thresholdValue = 0.6;
    }, 7000);

    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (!section) return;
    const videoAutoplay = section.dataset.videoAutoplay === "true";

    const videoWrappers = section.querySelectorAll('.customer_love_it_video');
    const isMobile = window.innerWidth <= 767;

    function loadHlsJs(callback) {
      if (window.Hls) {
        callback();
        return;
      }
      const script = document.createElement('script');
      script.src = "https://cdn.jsdelivr.net/npm/hls.js@latest";
      script.onload = () => callback();
      document.head.appendChild(script);
    }

    // ✅ Progress bar helper
    function attachVideoProgress(video, wrapper) {
      let progressBar = wrapper.querySelector('.video-progress-bar');
      if (!progressBar) {
        progressBar = document.createElement('div');
        progressBar.className = 'video-progress-bar';
        Object.assign(progressBar.style, {
          position: 'absolute',
          bottom: '10px',
          left: '10px',
          display: 'none',
          width: 'calc(100% - 20px)',
          height: '4px',
          background: 'rgba(255, 255, 255, 0.3)',
          borderRadius: '2px',
          overflow: 'hidden',
          zIndex: 3,
        });

        const progressFill = document.createElement('div');
        progressFill.className = 'video-progress-fill';
        Object.assign(progressFill.style, {
          width: '0%',
          height: '100%',
          background: '#fff',
          transition: 'width 0.2s linear',
        });

        progressBar.appendChild(progressFill);
        wrapper.appendChild(progressBar);
      }

      const progressFill = progressBar.querySelector('.video-progress-fill');
      let rafId = null;

      function updateProgress() {
        if (!video.paused && !video.ended && video.duration > 0) {
          const percent = (video.currentTime / video.duration) * 100;
          progressFill.style.width = `${percent}%`;
          rafId = requestAnimationFrame(updateProgress);
        }
      }

      video.addEventListener('play', () => {
        cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(updateProgress);
      });

      video.addEventListener('pause', () => {
        cancelAnimationFrame(rafId);
      });

      video.addEventListener('ended', () => {
        cancelAnimationFrame(rafId);
        progressFill.style.width = '0%';
      });

      video.addEventListener('loadedmetadata', () => {
        progressFill.style.width = '0%';
      });
    }

    // Loop through all videos
    videoWrappers.forEach((wrapper) => {
      const video = wrapper.querySelector('video');
      if (!video || video.dataset.initialized === 'true') return;
      video.dataset.initialized = 'true';

      const getSrc = () => isMobile ? video.dataset.mobileVideo : video.dataset.desktopVideo;
      const getPoster = () => isMobile ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      const showMute = (isMobile ? video.dataset.muteM : video.dataset.mute) === 'true';
      const showFullscreen = (isMobile ? video.dataset.fullscreenM : video.dataset.fullscreen) === 'true';

      const playBtn = wrapper.querySelector('.glb_play');
      const muteBtn = wrapper.querySelector('.glb_mute');
      const fullscreenBtn = wrapper.querySelector('.glb_fullscreen');

      //const shouldAutoplay = () => (wrapper.closest('div.carousel-cell.is-selected'));
      const shouldAutoplay = () => (isMobile ? video.dataset.autoplayM : video.dataset.autoplay) === 'true';

      let hls = null;
      let isNativeHLS = false;
      let isVideoLoaded = false;

      // Poster setup
      const posterUrl = getPoster();
      const posterWrapper = document.createElement('picture');
      posterWrapper.className = 'custom-poster-wrapper';
      Object.assign(posterWrapper.style, {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1,
        background: `url('${posterUrl}') center center / cover no-repeat`,
        pointerEvents: 'none',
        transition: 'opacity 0.4s ease',
        opacity: 1
      });

      wrapper.style.position = 'relative';
      wrapper.appendChild(posterWrapper);
      video._posterWrapper = posterWrapper;

      var mtp = true;
      video.removeAttribute('muted');
      if (shouldAutoplay()) {
        var mtp = true;
        video.setAttribute('muted', '');
      }
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('preload', 'metadata');
      video.muted = mtp;

      function safePlay( clicked = false) {
        const carousel = section.querySelector('.social-proof-slider-fl');
        const flkty = window.theme.Flickity.data(carousel);
        if (!flkty) return;
        const parentCell = video.closest('.carousel-cell');
        if (parentCell && !parentCell.classList.contains('is-selected')) {
          const cellIndex = flkty.cells.findIndex(cell => cell.element === parentCell);
          if (cellIndex >= 0) flkty.select(cellIndex);
        }

        setTimeout(() => {
          console.log("clicked",clicked);
          if( clicked ){  
            if (muteBtn) muteBtn.classList.remove('muted');
            video.muted = false;
          }
          const playPromise = video.play();
          if (playPromise && typeof playPromise.then === 'function') {
            playPromise
              .then(() => {
                
                playBtn?.classList.add('playing');
                video.onended = () => {
                  video.pause();
                  playBtn?.classList.remove('playing');
                  if (posterWrapper) posterWrapper.style.opacity = 1;
                  if (flkty) flkty.next();
                };
              })
              .catch(() => {
                playBtn?.classList.remove('playing');
                if (posterWrapper) posterWrapper.style.opacity = 1;
              });
          }
        }, 0);
      }

      video.addEventListener('playing', () => {
        if (posterWrapper) posterWrapper.style.opacity = 0;
      });

      function pauseVideo(otherVideo = null, vWrapper = null) {
        if (otherVideo) {
          otherVideo.pause();
          let otherPlayBtn = vWrapper.querySelector('.glb_play');
          otherPlayBtn?.classList.remove('playing');
          let otherPosterWrapper = vWrapper.querySelector('.custom-poster-wrapper');
          if (otherPosterWrapper) otherPosterWrapper.style.opacity = 1;
        } else {
          video.pause();
          playBtn?.classList.remove('playing');
          if (posterWrapper) posterWrapper.style.opacity = 1;
        }
      }

      function loadVideo() {
        const src = getSrc();
        var autoplay = shouldAutoplay();

        
        if (isVideoLoaded && video.getAttribute('data-loaded-src') === src) {
          if (autoplay) safePlay();
          return;
        }
        if (autoplay && video) {
          video.muted = true;
          if (muteBtn) muteBtn.classList.add('muted');
        }

        video.setAttribute('data-loaded-src', src);
        isNativeHLS = src.endsWith('.m3u8') && video.canPlayType('application/vnd.apple.mpegurl') !== '';

        if (src.endsWith('.m3u8')) {
          if (isNativeHLS) {
            video.src = src;
            video.setAttribute('preload', 'auto');
            video.load();
            isVideoLoaded = true;
            video.addEventListener('loadedmetadata', () => {
              attachVideoProgress(video, wrapper); // ✅ attach progress bar
              if (autoplay) safePlay();
            }, { once: true });
          } else {
            loadHlsJs(() => {
              if (window.Hls && Hls.isSupported()) {
                hls = new Hls({
                  maxBufferLength: 3,
                  startLevel: -1,
                  capLevelToPlayerSize: true
                });
                hls.loadSource(src);
                hls.attachMedia(video);
                video.hlsInstance = hls;

                hls.on(Hls.Events.MANIFEST_PARSED, () => {
                  isVideoLoaded = true;
                  attachVideoProgress(video, wrapper); // ✅ attach progress bar
                  if (autoplay) safePlay();
                });
              }
            });
          }
        } else {
          const source = document.createElement('source');
          source.src = src;
          source.type = 'video/mp4';
          video.appendChild(source);
          video.load();
          isVideoLoaded = true;
          video.addEventListener('loadedmetadata', () => {
            attachVideoProgress(video, wrapper); // ✅ attach progress bar
            if (autoplay) safePlay();
          }, { once: true });
        }

        playBtn?.classList.toggle('playing', autoplay);
      }

      // Observer logic
      function isVisible(entry, wrap) {
        const rect = entry.boundingClientRect;
        const intersection = entry.intersectionRect;
        const visibleRatio = intersection.width / rect.width;
        return visibleRatio >= thresholdValue && entry.isIntersecting;
      }

      function isOutOfView(el) {
        const rect = el.getBoundingClientRect();
        return (
          rect.bottom < 0 ||
          rect.top > window.innerHeight ||
          rect.right < 0 ||
          rect.left > window.innerWidth
        );
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const wrap = entry.target.closest('.customer_love_it_video');
          if (!wrap) return;
          const shouldPlay = isVisible(entry, wrap) && !isOutOfView(wrap);

          if (shouldPlay) {
            loadVideo();
          } else {
            pauseVideo();
          }
        });
      }, {
        threshold: Array.from({ length: 21 }, (_, i) => i / 20),
      });

      observer.observe(video);

      video.addEventListener('play', () => {
        offsoundAllVideos_social(wrapper);
        safePlay(true);
        video.muted = false;
        if (muteBtn) muteBtn.classList.remove('muted');
      });
      
      // video.addEventListener('play', () => {
      //   offsoundAllVideos_social(wrapper);
      //   safePlay(true);
      //   video.muted = false;
      //   if (muteBtn) muteBtn.classList.remove('muted');
      // });

      video?.addEventListener('click', () => {
        console.log("p----",video.paused)
      })
      // Controls
      // video?.addEventListener('click', () => {
      //   console.log("....cliked")
      //   if (video.paused) {
      //     offsoundAllVideos_social(wrapper);
      //     safePlay(true);
      //     video.muted = false;
      //     if (muteBtn) muteBtn.classList.remove('muted');
      //   } 
        
      // });
      playBtn?.addEventListener('click', () => {
        safePlay(true);
        video.muted = false;
        if (muteBtn) muteBtn.classList.remove('muted');
        
      });

      if (muteBtn) {
        muteBtn.style.display = showMute ? 'block' : 'none';
        muteBtn.classList.toggle('muted', video.muted);
        muteBtn.addEventListener('click', () => {
          video.muted = !video.muted;
          muteBtn.classList.toggle('muted', video.muted);
        });
      }

      if (fullscreenBtn) {
        fullscreenBtn.style.display = showFullscreen ? 'block' : 'none';
        fullscreenBtn.addEventListener('click', () => {
          if (video.requestFullscreen) {
            video.requestFullscreen();
          } else if (video.webkitEnterFullscreen) {
            video.webkitEnterFullscreen();
          } else if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen();
          }
        });
      }
    });
  }

  function initSocialProofSlider(section) {
    const desktop  = parseInt(section.dataset.desktop) || 3;
    const tablet   = parseInt(section.dataset.tablet)  || 2;
    const mobile   = parseInt(section.dataset.mobile)  || 1;
    const autoPlay = false;
    const wrap     = section.dataset.wrap === "true";
    const alignment = "left";

    const slider = section.querySelector(".social-proof-slider-fl");
    const totalSlides = slider.querySelectorAll(".carousel-cell").length;

    function getGroupCells() {
      if (window.innerWidth > 1024) return desktop;
      if (window.innerWidth >= 768)  return tablet;
      return mobile;
    }

    

    function getOptions() {
      const slidesToShow = getGroupCells();
      const contain_v = totalSlides <= slidesToShow;
      const wrap_v    = totalSlides > slidesToShow;

      return {
        cellAlign: alignment,
        contain: contain_v,
        imagesLoaded: true,
        wrapAround: wrap_v,
        autoPlay: autoPlay > 0 ? autoPlay : false,
        prevNextButtons: wrap_v,
        pageDots: false,
        draggable: wrap_v,
        touchVerticalScroll: false,
        adaptiveHeight: false,
      };
    }

    // init Flickity
    let flkty = new window.theme.Flickity(slider, getOptions());

    // reinit on resize if breakpoint changes
    let lastSlidesToShow = getGroupCells();
    let lastAlign = alignment;


    window.addEventListener("resize", () => {
      const newSlidesToShow = getGroupCells();
      const newAlign = alignment;

      if (newSlidesToShow !== lastSlidesToShow || newAlign !== lastAlign) {
        flkty.destroy();
        flkty = new window.theme.Flickity(slider, getOptions());
        lastSlidesToShow = newSlidesToShow;
        lastAlign = newAlign;
      } else {
        flkty.resize();
      }
    });
    flkty.on('change', () => {
      //const video_wrapper = section?.querySelector('.customer_love_it_video');
      offsoundAllVideos_social();
    });
    flkty.on('settle', () => {
      const currentCell = flkty.selectedElement;
      const video_wrapper = currentCell?.querySelector('.customer_love_it_video');
      offsoundAllVideos_social(video_wrapper);

      if (video_wrapper) {
        safePlayUsingFlickity(section, video_wrapper);
      }
    });
  }

  document.querySelectorAll(".socail_proof_slider").forEach(section => {
    const sectionID = section.getAttribute('data-section-id');
    initAutoPlayHlsVideos(sectionID);
    initSocialProofSlider(section);
  });
  document.addEventListener("shopify:section:load", function(event) {
    const section = event.target.querySelector(".socail_proof_slider");
    if (section) {
      const sectionID = section.getAttribute('data-section-id');
      initAutoPlayHlsVideos(sectionID);
      initSocialProofSlider(section);
    }
  });

  // CART-BAR: tidlig visning + scroll-til-pakkevalg ("Cart bar: vis tidligt + scroll til pakkevalg"-setting).
  // Native cart-bar (product.js) venter med at vise sig til hele køb-boksen er scrollet forbi, hvilket er
  // for sent når pakkevalget (Kaching) ligger langt nede. Denne udgave viser baren når pakkevalget
  // (.product__block--buttons - indeholder både Kaching-pakkevælgeren og den native buy-form) ikke er i
  // viewport - dukker op med det samme hvis boksen starter under folden, og forsvinder igen mens brugeren
  // faktisk kigger på pakkevalget (undgår at de to vises oveni hinanden, jf. operatør-feedback 2026-09-15).
  // Pilen skifter retning efter om pakkevalget er under (ned) eller allerede passeret (op) - samme
  // observer-entry der styrer synlighed bruges til retningen. Knappen scroller til selve pakkevalget,
  // ikke til ATC-knappen alene ([data-product-form] spænder kun formen, ikke Kaching-slotten før den).
  function initEarlyCartBar(section) {
    const cartBar = section.querySelector('#cart-bar');
    const target = section.querySelector('.product__block--buttons') || section.querySelector('[data-product-form]');
    if (!cartBar || !target || typeof IntersectionObserver === 'undefined') return;

    const arrow = cartBar.querySelector('[data-cart-bar-arrow] svg');

    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      cartBar.classList.toggle('is-visible', !entry.isIntersecting);
      if (arrow) {
        const isPastTarget = entry.boundingClientRect.top < 0;
        arrow.style.transform = isPastTarget ? 'rotate(180deg)' : 'rotate(0deg)';
      }
    });
    observer.observe(target);

    const scrollBtn = section.querySelector('[data-cart-bar-scroll]');
    if (scrollBtn) {
      scrollBtn.addEventListener('click', (event) => {
        event.preventDefault();
        if (window.theme && window.theme.scrollTo) {
          window.theme.scrollTo(target.getBoundingClientRect().top - 10);
        }
      });
    }
  }

  document.querySelectorAll('product-component[data-cart-bar-early-scroll]').forEach(initEarlyCartBar);
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('product-component[data-cart-bar-early-scroll]');
    if (section) initEarlyCartBar(section);
  });

})();



